import React from 'react';
import { useParams } from 'react-router-dom';
import Body from '../../components/Body';

export default function AboutUsPage() {
  return (
    <div className="container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-sm-12">
            <h3 className="text-center">
              <br />
              Why Shrikala &amp; Anand built Butterpuppies
            </h3>
            <img src="/dev.jpeg" style={{ width: '100%' }} alt="Dev" />
            <div>
              <br />
              <p>
                Butterpuppies was created by Shrikala and Anand - parents to 2-year-old Dev. Dev loves helicopters,
                excavators, butterflies &amp; puppies - and often wants to color all of them together.
              </p>
              <p>
                Thus was born Butterpuppies, a way to fuel our son's imagination with coloring pages designed specifically for
                him. Dev now verbalizes what he wants to color, inspired by all the things he sees in the world.
              </p>
              <p>
                Unlike generic, mass-produced coloring books, our coloring pages cater to the unique interests and imaginative
                whims of each child. Simply put, it's more fun!
              </p>
              <p>
                The American Academy of Pediatrics (AAP) says that activities like coloring can significantly benefit a child's
                cognitive, language, and self-regulation skills. Learn more{' '}
                <a
                  href="https://publications.aap.org/pediatrics/article/142/3/e20182058/38649/The-Power-of-Play-A-Pediatric-Role-in-Enhancing"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>.
              </p>
              <p>What will your child imagine and create today?</p>
              <hr />
              <br />
              <br />
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}